import { formatNumber, parsePhoneNumberWithError, PhoneNumber } from 'libphonenumber-js'
import type { NumberFormat } from 'libphonenumber-js'

export default () => {
  const phone = (value: string, format: NumberFormat = 'NATIONAL'): string => {
    if (!value || value.length === 5) {
      return value
    }
    try {
      const parsed: PhoneNumber = parsePhoneNumberWithError(value)
      if (parsed.country !== 'US' && format === 'NATIONAL') {
        // Still format non-US numbers internationally
        return parsed.formatInternational()
      }
      return formatNumber(value, format)
    } catch {
      return value
    }
  }
  // fixDirection: otherwise css "direction: rtl" would reverse the symbols order
  const fixDirection = (value: string): string => value ? value.split(' ').reverse().join(' ') : value
  const NO_LETTERS_AND_NUMBERS_REGEX = /[^a-zA-Z0-9]/g
  const onlyLettersAndNumbers = (value: string): string => !value ? value : value.replace(NO_LETTERS_AND_NUMBERS_REGEX, '').toLowerCase()
  const getSpeakerLabel = (speaker: string) => {
    if (speaker === '1' || speaker === '2') {
      return `Speaker ${speaker}`
    } else { return speaker }
  }
  return {
    phone,
    fixDirection,
    onlyLettersAndNumbers,
    getSpeakerLabel
  }
}
